import React from 'react'
import {ModulePanel, ModuleHeader, ModuleBody, ModuleFooter} from 'containers/purchase/modules/module_panel'
import {ListGroup} from 'reactstrap'
import ListItemOption from 'ui/list_item_option'
import { useTranslation } from 'react-i18next'
import {currency} from 'i18n/config'
import {get} from 'lodash'
import parse from 'react-html-parser'
import cn from 'classnames'

const TourcmsComponentModule = (props) => {
  const {machine, status} = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { tickets, components, component } = current.context

  const isFetching = current.matches({tourcmsComponentStep: 'fetchingComponents'}) ? true : false

  const onComponentSeleted = (component) => send({type: 'COMPONENT_SELECTION', component: component})

  const ComponentSelect = () => {
    const componentsList = Array.isArray(components) ? components : [components]

    if (!components || components.length <= 0) {
      return (
        <div className="alert alert-warning">
          {i18n.t('tourcms_component_module.no_availability')}
        </div>
      )
    }

    return (
      <ListGroup>
        {componentsList.map((c) => {
          const {component_key, date_code, note, special_offer_note, total_price, price_breakdown} = c

          const price = get(price_breakdown, 'price_row')

          let priceList = []
          if (Array.isArray(price)) {
            priceList = price
          } else {
            priceList.push(price)
          }

          const componentDescription = (date_code, note, special_offer_note) => {
            let text

            if (date_code || note) {
              if (date_code && note) {
                text = `${date_code} - ${note}`
              } else if (!date_code) {
                text = note
              } else {
                text = date_code
              }
            } else {
              text = special_offer_note
            }

            return <div>{text}</div>
          }

          return (
            <ListItemOption
              key={component_key}
              active={component.component_key == component_key}
              onClick={() => onComponentSeleted(c)}
            >
              <div className={'align-self-center text-center text-md-left'}>
                <div className="font-weight-bold">
                  {componentDescription(date_code, note, special_offer_note)}
                </div>
                <div>
                  {priceList.map((p) => (
                    <span key={p['rate-id']} className="mr-3">{parse(p.text)}</span>
                  ))}
                </div>
              </div>
              <div className={'d-flex align-self-center text-right'}>
                <div className="price text-right font-weight-bold" style={{fontSize: '18px', width: '200'}}>
                  {i18n.t('tourcms_component_module.total_price', {price: currency(total_price)})}
                </div>
              </div>
            </ListItemOption>
          )})}
      </ListGroup>
    )
  }

  return (
    <ModulePanel>
      <ModuleHeader status={status} onClick={() => status == 'completed' ? send('REOPEN_TOURCMSCOMPONENTSTEP') : null}>
        <span>
          <i className="fa fa-star mr-2" aria-hidden="true"></i>
          {i18n.t('tourcms_component_module.select_a_modality')}
        </span>
      </ModuleHeader>
      <ModuleBody status={status}>
        {isFetching ? (
          <div className="alert alert-info" role="alert">
            <i className="far fa-clock mr-2" aria-hidden="true"></i>
            {i18n.t('tourcms_component_module.searching_modalities')}
          </div>
        ) : (
          <React.Fragment>
            {components &&
              <ComponentSelect/>
            }

            {!components &&
              <div className="alert alert-info" role="alert">
                <i className="fa fa-warning mr-2" aria-hidden="true"></i>
                {i18n.t('tourcms_component_module.no_components')}
              </div>
            }
          </React.Fragment>
        )}
      </ModuleBody>
      <ModuleFooter {...props}/>
    </ModulePanel>
  )
}

export default TourcmsComponentModule
